import { useGA4Dispatcher } from '@jusbrasil-web/shared-ga4'
import {
  GA4ClickEvent,
  GA4ClickEventProps,
  GA4InputStartEvent,
  GA4InputStartEventProps,
  GA4InputSubmitEvent,
  GA4InputSubmitEventProps,
  GA4ViewItemListEvent,
  GA4ViewItemListRenderProps,
} from '@jusbrasil-web/shared-ga4-events'

import { GA4EventHandlers } from './types'

export const useGA4Events = (): GA4EventHandlers => {
  const { sendGA4Event } = useGA4Dispatcher()

  const sendComponentRender = (properties: {
    componentClass?: string | null
    componentName?: string | null
    renders?: GA4ViewItemListRenderProps[] | null
  }) => {
    const event = new GA4ViewItemListEvent(properties)
    sendGA4Event(event)
  }

  const sendInputSubmitComponent = (eventProps: GA4InputSubmitEventProps) => {
    const event = new GA4InputSubmitEvent({
      ...eventProps,
    })
    sendGA4Event(event)
  }

  const sendClick = (eventProps: GA4ClickEventProps) => {
    const event = new GA4ClickEvent({
      ...eventProps,
    })
    sendGA4Event(event)
  }

  const sendInputStart = (eventProps: GA4InputStartEventProps) => {
    const event = new GA4InputStartEvent({
      ...eventProps,
    })
    sendGA4Event(event)
  }

  return { sendComponentRender, sendInputSubmitComponent, sendClick, sendInputStart }
}
